import { useEffect, useState } from "react";

/**
 * Sichqoncha ustiga kelganda rasmlarni sekin almashtiradi (qo'lda tanlangan rasm ham shu yerdan boshqariladi).
 * Sichqoncha ketganda to'xtaydi; keyingi rasmlar oldindan yuklanadi.
 */
export function useHoverCycle(images: string[], intervalMs = 1600) {
  const [index, setIndex] = useState(0);
  const [hover, setHover] = useState(false);
  const count = images.length;

  useEffect(() => {
    if (!hover || count < 2) return undefined;
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
    const timer = window.setInterval(() => setIndex((value) => (value + 1) % count), intervalMs);
    return () => window.clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hover, count, intervalMs]);

  return {
    index: Math.min(index, Math.max(count - 1, 0)),
    setIndex,
    hoverProps: {
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
    },
  };
}
